/* istanbul ignore file */
export type ObjType = {
  state: string;
  nextState: string | null;
  nextUrl: string;
  allowedUrls: string[];
  version?: string;
};

export const states: ObjType[] = [
  // common states
  {
    state: 'initialized',
    nextState: 'personal_data_form',
    nextUrl: '/register',
    allowedUrls: ['/callback', '/instructions'],
  },
  {
    state: 'background_check_disapproved',
    nextState: null,
    nextUrl: '/',
    allowedUrls: ['/register/disapproval'],
  },
  {
    state: 'background_check_approved',
    nextState: null,
    nextUrl: '/',
    allowedUrls: ['/register/approval'],
  },
  {
    state: 'financing_granted',
    nextState: null,
    nextUrl: '/',
    allowedUrls: ['/register/approval'],
  },
  {
    state: 'education_contract_signed',
    nextState: null,
    nextUrl: '/',
    allowedUrls: ['/register/approval'],
  },
  {
    state: 'awaiting_contract_signature',
    nextState: null,
    nextUrl: '/',
    allowedUrls: ['/register/approval'],
  },
  {
    state: 'financing_contract_signed',
    nextState: null,
    nextUrl: '/',
    allowedUrls: ['/register/approval'],
  },

  // V1 (fifteen_delay)
  {
    state: 'personal_data_form',
    nextState: 'score_guarantor_registration',
    nextUrl: '/register/guarantor-form',
    allowedUrls: ['/register'],
    version: 'V1',
  },

  // v2
  {
    state: 'personal_data_form',
    nextState: 'first_guarantor_registration_form',
    nextUrl: '/register/guarantors',
    allowedUrls: ['/register'],
    version: 'V2',
  },
  {
    state: 'guarantors_disapproved',
    nextState: 'first_guarantor_registration_form',
    nextUrl: '/register/first-person-guarantor',
    allowedUrls: ['/register/guarantors'],
  },
  {
    state: 'guarantor_registration',
    nextState: 'first_guarantor_registration_form',
    nextUrl: '/register/first-person-guarantor',
    allowedUrls: ['/register/guarantors'],
  },
  {
    state: 'first_guarantor_registration_form',
    nextState: 'second_guarantor_registration_form',
    nextUrl: '/register/second-person-guarantor',
    allowedUrls: ['/register/first-person-guarantor', '/register/guarantors'],
  },
  {
    state: 'second_guarantor_registration_form',
    nextState: 'guarantor_registration_completed',
    nextUrl: '/register/guarantors',
    allowedUrls: ['/register/second-person-guarantor', '/register/guarantors'],
  },
  {
    state: 'guarantor_registration_completed',
    nextState: 'background_check',
    nextUrl: '/register/wait-analysis',
    allowedUrls: [
      '/register/guarantors',
      '/register/first-person-guarantor',
      '/register/second-person-guarantor',
    ],
  },
  {
    state: 'give_up_financing',
    nextState: null,
    nextUrl: '/',
    allowedUrls: ['/redirect-education'],
  },
  {
    state: 'background_check',
    nextState: null,
    nextUrl: '/',
    allowedUrls: ['/register/wait-analysis'],
  },

  // v3
  {
    state: 'personal_data_form',
    nextState: 'score_guarantor_registration',
    nextUrl: '/register/guarantor-form',
    allowedUrls: ['/register'],
    version: 'V3',
  },
  {
    state: 'score_guarantor_registration',
    nextState: 'score_registration_completed',
    nextUrl: '/register/guarantors',
    allowedUrls: ['/register/guarantor-form', '/register/guarantors'],
  },
  {
    state: 'first_guarantor_registration',
    nextState: 'second_guarantor_registration',
    nextUrl: '/register/second-person-guarantor',
    allowedUrls: ['/register/first-person-guarantor', '/register/guarantors'],
  },
  {
    state: 'second_guarantor_registration',
    nextState: 'credit_registration_completed',
    nextUrl: '/register/guarantors',
    allowedUrls: ['/register/second-person-guarantor', '/register/guarantors'],
  },
  {
    state: 'score_registration_completed',
    nextState: 'score_background_check',
    nextUrl: '/register/wait-analysis',
    allowedUrls: [
      '/register/guarantors',
      '/register/guarantor-form',
      '/register/first-person-guarantor',
      '/register',
    ],
  },
  {
    state: 'credit_registration_completed',
    nextState: 'credit_background_check',
    nextUrl: '/register/wait-analysis',
    allowedUrls: [
      '/register/guarantors',
      '/register/guarantor-form',
      '/register/first-person-guarantor',
      '/register/second-person-guarantor',
    ],
  },
  {
    state: 'score_disapproved',
    nextState: 'second_guarantor_registration',
    nextUrl: '/register/second-person-guarantor',
    allowedUrls: ['/register/guarantors', '/register/disapproval'],
  },
  {
    state: 'credit_disapproved',
    nextState: 'first_guarantor_registration',
    nextUrl: '/register/first-person-guarantor',
    allowedUrls: ['/register/guarantors'],
  },
  {
    state: 'give_up_score_check',
    nextState: null,
    nextUrl: '/',
    allowedUrls: ['/redirect-education'],
  },
  {
    state: 'give_up_credit_check',
    nextState: null,
    nextUrl: '/',
    allowedUrls: ['/redirect-education'],
  },
  {
    state: 'score_background_check',
    nextState: null,
    nextUrl: '/',
    allowedUrls: ['/register/wait-analysis'],
  },
  {
    state: 'credit_background_check',
    nextState: null,
    nextUrl: '/',
    allowedUrls: ['/register/wait-analysis'],
  },
];
